import { type SkillDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Response = SkillDto[] | undefined;

interface Return {
  error: AxiosError | null;
  isGettingSkills: boolean;
  skills: Response;
}

export const useGetSkillsAssessment = (): Return => {
  const { restSkillsApi } = useApiClient();
  const { user } = useUserContext();

  const { data, error, isLoading } = useQuery<Response, AxiosError>({
    enabled: !!user?.userId,
    queryFn: async () => {
      if (user?.userId) {
        const response = await restSkillsApi.getActiveSkills(user.userId);

        return response.data;
      }

      return undefined;
    },
    queryKey: [QueryKeyEnum.GET_SKILLS_ASSESSMENT],
  });

  return { error, isGettingSkills: isLoading, skills: data };
};
